import React from 'react';
import { Row, Col } from 'antd';

import { ProfileCorporateInfoModel } from 'api/backofficeApiClient';
import BillingInfoSection from './BillingInfoSection';
import PrimaryContactSection from './PrimaryContactSection';
import SupervisorInfoSection from './SupervisorInfoSection';
import TimesheetApproverInfoSection from './TimesheetApproverInfoSection';

type Props = {
  corporateInfo?: ProfileCorporateInfoModel;
};

export default function RecruiterAdditionalInfoSection(props: Props) {
  const { corporateInfo } = props;

  return (
    <Row gutter={[10, 10]}>
      <Col xs={24} md={12} className="d-flex">
        <BillingInfoSection corporateInfo={corporateInfo} />
      </Col>

      <Col xs={24} md={12} className="d-flex">
        <PrimaryContactSection corporateInfo={corporateInfo} />
      </Col>

      <Col xs={24} md={12} className="d-flex">
        <SupervisorInfoSection corporateInfo={corporateInfo} />
      </Col>

      <Col xs={24} md={12} className="d-flex">
        <TimesheetApproverInfoSection corporateInfo={corporateInfo} />
      </Col>
    </Row>
  );
}
